/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CameraIntrinsicsFromJSON, CameraIntrinsicsToJSON, StreemApiPointFromJSON, StreemApiPointToJSON, StreemApiPoseFromJSON, StreemApiPoseToJSON, StreemApiSizeFromJSON, StreemApiSizeToJSON, } from './';
export function WallItemStreemshotFromJSON(json) {
    return WallItemStreemshotFromJSONTyped(json, false);
}
export function WallItemStreemshotFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'inResponseToWallItemId': !exists(json, 'in_response_to_wall_item_id') ? undefined : json['in_response_to_wall_item_id'],
        'downloadUrl': !exists(json, 'download_url') ? undefined : json['download_url'],
        'pose': !exists(json, 'pose') ? undefined : StreemApiPoseFromJSON(json['pose']),
        'featurePoints': !exists(json, 'feature_points') ? undefined : (json['feature_points'].map(StreemApiPointFromJSON)),
        'storageUrl': !exists(json, 'storage_url') ? undefined : json['storage_url'],
        'cameraIntrinsics': !exists(json, 'camera_intrinsics') ? undefined : CameraIntrinsicsFromJSON(json['camera_intrinsics']),
        'imageDimensions': !exists(json, 'image_dimensions') ? undefined : StreemApiSizeFromJSON(json['image_dimensions']),
    };
}
export function WallItemStreemshotToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'in_response_to_wall_item_id': value.inResponseToWallItemId,
        'download_url': value.downloadUrl,
        'pose': StreemApiPoseToJSON(value.pose),
        'feature_points': value.featurePoints === undefined ? undefined : (value.featurePoints.map(StreemApiPointToJSON)),
        'storage_url': value.storageUrl,
        'camera_intrinsics': CameraIntrinsicsToJSON(value.cameraIntrinsics),
        'image_dimensions': StreemApiSizeToJSON(value.imageDimensions),
    };
}
//# sourceMappingURL=WallItemStreemshot.js.map